import { useQuery } from '@tanstack/react-query';
import { getWorkSummary, type WorkSummaryDto } from './api.js';
import { queryKeys } from './query-keys.js';

/**
 * R4 — the ONE source of destination badge counts. Every hub/nav badge reads
 * from here (count-truth: the number on the door equals the items in the room,
 * because the server count shares each list's WHERE). Never derive a badge from
 * a feed array's `.length`.
 */
export function useWorkSummary() {
  return useQuery<WorkSummaryDto>({
    queryKey: queryKeys.workSummary,
    queryFn: () => getWorkSummary(),
    refetchInterval: 30_000,
    staleTime: 10_000,
  });
}
